import { render } from "./AirportTrafficBlogsPage.vue?vue&type=template&id=3a13ed6d"
import script from "./AirportTrafficBlogsPage.vue?vue&type=script&lang=js"
export * from "./AirportTrafficBlogsPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__